import { desktopMediaQuery } from '@lib/media-query';

export default function isDesktop(): boolean {
    return desktopMediaQuery().matches;
}
